import { Instance } from 'mobx-state-tree'
import { WordpressTokenModelBase } from './WordpressTokenModel.base'

/* The TypeScript type of an instance of WordpressTokenModel */
export interface WordpressTokenModelType extends Instance<typeof WordpressTokenModel.Type> {}

/* A graphql query fragment builders for WordpressTokenModel */
export {
  selectFromWordpressToken,
  wordpressTokenModelPrimitives,
  WordpressTokenModelSelector
} from './WordpressTokenModel.base'

/**
 * WordpressTokenModel
 */
export const WordpressTokenModel = WordpressTokenModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
